"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentTemplate = void 0;
var DocumentTemplate;
(function (DocumentTemplate) {
    DocumentTemplate["BillOfLading"] = "bill_of_lading";
    DocumentTemplate["CarrierEarningsReport"] = "carrier_earnings_report";
    DocumentTemplate["Invoice"] = "invoice";
    DocumentTemplate["RateConfirmation"] = "rate_confirmation";
    DocumentTemplate["ShippingLabel"] = "shipping_label";
    DocumentTemplate["Statement"] = "statement";
    DocumentTemplate["Table"] = "table";
    DocumentTemplate["XPODeliveryReceipt"] = "xpo_delivery_receipt";
})(DocumentTemplate = exports.DocumentTemplate || (exports.DocumentTemplate = {}));
//# sourceMappingURL=documentTemplate.js.map